export default "__VITE_ASSET__952b8905__"